import { forwardRef, type Ref, type SVGProps } from "react";

function SvgDressCode(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="square"
        strokeLinejoin="round"
        d="M13.95 7.71 15 4.736l-4.9-2.404c-.684 2.243-3.516 2.243-4.2 0L1 4.737 2.05 7.71l1.617-.774v6.732h8.666V6.935z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgDressCode);
export default ForwardRef;
